export default "__VITE_ASSET__CPastypR__"